import React from "react";
import Paper from "@material-ui/core/Paper";
import InputsForm from "./InputsForm.js";
import ActionsForm from "./ActionsForm.js";
import Style from "../../styles/js/StyleNotifications.js";
import Typography from "@material-ui/core/Typography";
import ListErrors from "../../components/common/ListErrors.js";
import * as ScreenText from "../../consts/ScreenText.js";

export default function NotificationsForm({
  state,
  handleChange,
  setInitialState,
  handleSubmit,
  disabled,
  errors,
}) {
  const style = Style();

  return (
    <Paper className={style.notificationsForm}>
      <Typography variant="h4" gutterBottom>
        {ScreenText.NOTIFICATIONS_TITLE}
      </Typography>
      <InputsForm state={state} handleChange={handleChange} />
      <ListErrors errors={errors} />
      <ActionsForm
        handleSubmit={handleSubmit}
        setInitialState={setInitialState}
        disabled={disabled}
      />
    </Paper>
  );
}
